import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { InvoiceAttachmentsSurface } from './InvoiceAttachmentsSurface';
export { InvoiceAttachmentsSurface };
/**
 * `InvoiceAttachments` — the composition root, mounted by `react_component` from the invoice show
 * page when `new_attachment_direct_uploads_enabled?` is true.
 * `InvoiceAttachmentsSurface` configures the shared `@features/Attachments` surface; this
 * wrapper's own job is only the `QueryClientProvider` every mounted island owns for itself
 * (mirrors `BuildingAttachments`, `InspectionAttachments` and `WorkOrderAttachments`).
 */
function InvoiceAttachments(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InvoiceAttachmentsSurface, Object.assign({}, props))));
}
export default InvoiceAttachments;
